import React from 'react'
import "./styles.css"
import {Text} from "atmosfair-ui"
import LogoutButton from "../../../molecules/logout-button/LogoutButton";
import KlimaLinkLogo from "../../../molecules/logos/klima-link-logo/KlimaLinkLogo";

const NoRoute = () => {
    return <div className={"no-route-container"}>
        <LogoutButton/>
        <Text variant={"headlineMedium"}>SCREENS.NO_ROUTE.TITLE</Text>
        <KlimaLinkLogo alt={"KLIMALINK_LOGO"} size={"medium"}/>
    </div>
}

export default NoRoute